import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IncidentReportDataInterface } from '../../hooks/dashboard/dashboard/useIncidentReport';

interface IInitialState {
  incidentReportData?: IncidentReportDataInterface;
}

const initialState: IInitialState = {
  incidentReportData: undefined,
};

const incidentReportSlice = createSlice({
  name: 'incidentReportSlice',
  initialState,
  reducers: {
    setIncidentReportData(state, action: PayloadAction<IncidentReportDataInterface>) {
      state.incidentReportData = action.payload;
    },
  },
});

export const incidentReportActions = incidentReportSlice.actions;
export default incidentReportSlice.reducer;
